import { Component, HostBinding, Input, inject } from '@angular/core';

import { TeamType } from '@frontend/sports/betting-offer/feature/model';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { sumBy } from 'lodash-es';

import { BaseBallscoreboardViewModel } from '../../../../../scoreboards/models/baseball-scoreboard.viewmodel';
import { ScoreboardStat } from '../../../../../scoreboards/models/scoreboard-stats';
import { ScoreboardComponentBase } from '../../../../../scoreboards/scoreboard-base.component';

@Component({
    selector: 'ms-my-bets-base-ball-scoreboard',
    templateUrl: './my-bets-baseball-scoreboard.html',
})
export class MyBetsBaseballScoreboardComponent extends ScoreboardComponentBase {
    sitecore = inject(Sitecore);

    @Input() override vm: BaseBallscoreboardViewModel;

    playerSum = 0;
    extraInnings: ScoreboardStat[];
    teamType = TeamType;
    defaultInnings = 9;

    @HostBinding('class') className = 'mybets-scoreboard';

    getSum(vm: ScoreboardStat[], player: TeamType): number {
        const extraInnings = this.getExtraInnings(vm, player);
        const playerSum = this.getPlayerSum(extraInnings);

        return playerSum;
    }

    getExtraInnings(vm: ScoreboardStat[], player: TeamType): ScoreboardStat[] {
        return vm.slice(this.defaultInnings).filter((inning) => {
            return player === TeamType.Team01 ? +inning.player1 > 0 : +inning.player2 > 0;
        });
    }

    getPlayerSum(extraInnings: ScoreboardStat[]): number {
        return sumBy(extraInnings, (set) => {
            return +set.player1 || +set.player2;
        });
    }
}
